import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-screen bg-stone-950 text-white fixed top-0 left-0 w-full h-full z-50"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 1, delay: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="animate-spin h-14 w-14 border-4 border-sky-400 border-t-transparent rounded-full"
        initial={{ scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      />
      <motion.p className="mt-4 text-lg" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
        Loading...
      </motion.p>
    </motion.div>
  );
}
